import { all, call, put, takeLatest } from "redux-saga/effects";

import {
    STROLLER_REVIEWS_FETCH_TRIGGER,
    StrollerReviewsFetchNormalizedResponse,
    StrollerReviewsFetchTriggerAction,
    strollerReviewsFetchApi,
} from "@/mk2/apps/strollers/containers/StrollerReviews/StrollerReviews.actions";
import { XHRAction, XHRGetError, handleXHRGetErrorSaga, normalizeError } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { strollers_api_v2_reviews_get_url } from "@/mk/urls/functions";

const logger = getLogger("strollers/StrollerReviews.sagas");

interface FetchApiResponse {
    body: StrollerReviewsFetchNormalizedResponse;
}

function* fetchStrollerReviews({
    strollerSlug,
    xhr,
}: StrollerReviewsFetchTriggerAction & XHRAction) {
    yield put(strollerReviewsFetchApi.request(strollerSlug));

    try {
        const response: FetchApiResponse = yield call(() =>
            xhr.get(strollers_api_v2_reviews_get_url({ strollerSlug })),
        );

        yield put(strollerReviewsFetchApi.success(strollerSlug, response.body));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(strollerReviewsFetchApi.failure(strollerSlug, normalizeError(error)));
    }
}

export default function* root() {
    yield all([takeLatest(STROLLER_REVIEWS_FETCH_TRIGGER, fetchStrollerReviews)]);
}
